export default "__VITE_ASSET__BQaZeSIu__"